import TableColumn from "@component/common/TableColumn";
import TableHeader from "@component/common/TableHeader";
import { QNA_INFO } from "@constant/QNA_INFO";

export default function QNAColumn() {
  return (
    <TableHeader>
      {QNA_INFO.map(({ COLUMN, WIDTH }, index) => {
        return (
          <TableColumn key={index} width={WIDTH}>
            {COLUMN}
          </TableColumn>
        );
      })}
    </TableHeader>
  );
}
